var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InstanceDash',{attrs:{"type":_vm.type,"instance":_vm.instance,"fields":_vm.fields,"on-update":_vm.onUpdate,"on-submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }